/**
 * 基础菜单 商品管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>留言板</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="searchForm" class="user-search">
        
      <el-form-item label="搜索：">
        <el-input size="small" v-model="searchForm.title" placeholder="输入留言标题"></el-input>
      </el-form-item>

      <el-form-item label="">
        <el-input size="small" v-model="searchForm.emailOrphone" placeholder="输入邮箱"></el-input>
        <!-- <el-select size="small" v-model="searchForm.name_id" clearable placeholder="选择公司名称">
          <el-option v-for="item in conpmanyOptions" :key="item.value" :label="item.name" :value="item.name_id">
          </el-option>
        </el-select> -->
      </el-form-item>


      <!-- <el-form-item label="">
        <el-select size="small" v-model="searchForm.states" clearable @change="changeVal" placeholder="选择文章状态">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item> -->
      
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <!-- <el-button size="small" type="primary" icon="el-icon-plus" @click="handleAdd()">添加</el-button> -->
        <el-button size="small" type="danger" icon="el-icon-plus" @click="batchDel()">批量删除</el-button>
      </el-form-item>
    </el-form>

    <!--列表-->
    <el-table @select="handleSelect" @select-all="handleSelect" size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中"
      style="width: 100%;">
      <el-table-column align="center" type="selection" width="60">
      </el-table-column>
      <el-table-column sortable prop="title" label="留言标题" width="300">
      </el-table-column>
      <el-table-column sortable prop="emailOrphone" label="邮箱" width="300">
      </el-table-column>

      <el-table-column sortable prop="content" label="留言内容" width="300">
      </el-table-column>

      <el-table-column sortable prop="createDate" label="留言时间" width="300">
      </el-table-column>

      <el-table-column align="center" label="操作" min-width="300">
        <template slot-scope="scope">
          <!-- <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button> -->
          <el-button size="mini" type="danger" @click="deleteUser(scope.$index, scope.row)">删除</el-button>
          
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <!-- <Pagination v-bind:child-msg="pageparm" @callFatherTwo="callFatherTwo" @callFather="callFather"></Pagination> -->

    <el-pagination class="page-box" @size-change="handleSizeChange" @current-change="handleCurrentChange" background
      :current-page="pageparm.index" :page-sizes="[10, 20, 30, 40]" :page-size="pageparm.pageSize"
      layout="total, sizes, prev, pager, next, jumper" :total="pageparm.total">
    </el-pagination>


  </div>
</template>

<script>
// import { deptSave, deptDelete } from '../../api/userMG'
import { delMessageboard, getArticleList,getMessageboard } from "../../api/newApis"
import Pagination from '../../components/Pagination'
import { getCompanyList } from "../../api/newApis"
export default {
  data() {
    return {
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
    //   editFormVisible: false, //控制编辑页面显示与隐藏
      listData:[],
      batchIds:[],//批量删除的id
      title: '添加',
      state: "",
      conpmanyOptions: null,
      options: [{
        label: "已发布",
        value: 1
      }, {
        label: "待发布",
        value: 0
      }
      ],
      searchForm: {
        title: "",
        companyName: "",
        states: "",
      },

      // 分页参数
      pageparm: {
        index: null,
        pageSize: null,
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    // this.getdata(this.formInline)
    this.getMessageBoard()
    // this.getArticle()
    this.getCompany()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    changeVal(val) {
      console.log(val);
    },

    selectAll(data){
      console.log(data);
    },
    
    batchDel(){
      this.$confirm('确定要删除选中的文章吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async ()=>{
        let res = await delMessageboard(this.batchIds)
      if (res.code == 200) {
        this.$message.success("删除成功")
        this.getMessageBoard()
      } else {
        this.$message.error(res.msg)
      }
      }).catch(()=>{
        this.$message.error("已取消删除")
      })
    },

    handleSelect(selection,row){
      this.batchIds =  selection.map(item=>{
        return item.id
      })
      this.batchIds = this.batchIds.join(',')
    },


    //搜索
    search() {
      console.log(11111, this.searchForm);
      this.getArticleTwo(this.searchForm)
    },


    //获取文章列表方法二
    async getArticleTwo(params) {
      let res = await getMessageboard(params)
      this.listData = res.data.list
      this.pageparm.total = res.data.total
      this.pageparm.pageSize = res.data.pageSize
      this.pageparm.index = res.data.index
    },

    async getMessageBoard() {
      console.log(1111,this.pageparm);
      let res = await getMessageboard(this.pageparm)
      console.log(11111,res);
      this.listData = res.data.list
      this.pageparm.total = res.data.total
      this.pageparm.pageSize = res.data.pageSize
      this.pageparm.index = res.data.index
    },

    //获取公司列表
    async getCompany() {
      const res = await getCompanyList()
      this.conpmanyOptions = res.data
    },

    handleSizeChange(val) {
      console.log(this.pageparm);
      this.pageparm.pageSize = val
      this.getMessageBoard()
    },

    handleCurrentChange(val) {
      console.log(this.pageparm);
      this.pageparm.index = val
      this.getMessageBoard()
    },

   


  
    // 删除公司
     deleteUser(index, row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async ()=>{
        let res = await delMessageboard(row.id + "")
      if (res.code == 200) {
        this.$message.success("删除成功")
        this.getMessageBoard()
      } else {
        this.$message.error(res.msg)
      }
      }).catch(()=>{
        this.$message.error("已取消删除")
      })
    },


  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}

.userRole {
  width: 100%;
}
</style>

 
 


// WEBPACK FOOTER //
// src/views/messageboard/index.vue